import { Component, DoCheck, Input, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { each, find } from 'lodash';
import { InpiFieldError } from '../../inpi';

import { RecordLink } from '../../record-link/record-link';
import { Record, RecordField } from '../../record/record';


const NUMBER_REGEX = /^[0-9]*$/;

const SHAREHOLDER_LINK = process.env.SHAREHOLDER_LINK;
const SHARES_TOTAL_FIELD = process.env.SHARES_TOTAL_FIELD;
const SHARES_FIELDS = [
  process.env.SHARES_TOTAL_FIELD,
  process.env.SHARES_PP_FIELD,
  process.env.SHARES_UF_FIELD,
  process.env.SHARES_NP_FIELD,
  process.env.SHARES_AT_FIELD,
];

@Component({
  selector: 't-record-link-form',
  templateUrl: './record-link-form.component.html',
})
export class RecordLinkFormComponent implements DoCheck {
  
  @Input()
  link: RecordLink

  @Input()
  rootLink: RecordLink

  @Input()
  inpiFieldErrors?: InpiFieldError[]

  @Output()
  fixIssue = new EventEmitter();

  currentRecord: Record
  fields: RecordField[]

  sharesFields: RecordField[]
  totalSharesField: RecordField
  totalShares: any

  booleanOptions = [
    {
      value: 'Oui',
      text: 'Oui'
    },
    {
      value: '',
      text: 'Non'
    }
  ];

  constructor(private builder: FormBuilder) { }

  ngDoCheck() {
    this.buildForm();
  }


  buildForm() {
    // Save reference of the current record
    this.currentRecord = this.link.record;
    
    let linkFields: RecordField[] = [];
    let typeField: RecordField;

    let recordFields: RecordField[] = [];
    let nameField: RecordField;

    this.sharesFields = [];

    let linkModel = this.link.model;

    // Get the total number of shares for the company
    let companySharesField = find(this.rootLink.record.fields, f => f.name === process.env.COMPANY_SHARES_FIELD);

    if(companySharesField) {
      this.totalShares = companySharesField.value;

      this.totalShares = parseInt(this.totalShares, 10);
    }


    // Build link fields
    each(linkModel.fields, (fieldModel, fieldModelId) => {
      let field = find(this.link.fields, field => field.name === fieldModelId);

      // Create the field on the fly
      if(!field) {
        field = new RecordField();
        field.name = fieldModelId;
        field.model = fieldModel;
        field.selectDefaultValue();

        this.link.fields.push(field);
      }
      else {
        field.model = fieldModel;
      }

      // Save references of link fields for later use
      if (field.name === 'type') {
        typeField = field;
      }

      // Shares fields
      else if (this.link.name === SHAREHOLDER_LINK && SHARES_FIELDS.indexOf(field.name) >= 0) {
        let control = new FormControl(field.value, [
          Validators.pattern(NUMBER_REGEX)
        ]);

        control.valueChanges.subscribe((value) => {
          field.value = value;

          if(field !== this.totalSharesField) {
            this.refreshTotalShares();
          }
        });

        field.control = control;

        if(field.name === SHARES_TOTAL_FIELD) {
          field.model.input = 'shares';
          
          linkFields.push(field);
          this.totalSharesField = field;
          
          control.disable();
        }
        else {
          this.sharesFields.push(field);
        }
      }

      // Other fields
      else {
        linkFields.push(field);
      }
    });

    // Get the corresponding record model (Using the typeField value)
    let recordModel = linkModel.types[typeField.value];

    // Assign the new record model
    this.link.record.model = recordModel;

    // Build record fields
    each(recordModel, (fieldModel, fieldModelId) => {
      let field = find(this.link.record.fields, field => field.name === fieldModelId);

      // Create the field on the fly
      if(!field) {
        field = new RecordField();
        field.name = fieldModelId;
        field.model = fieldModel;
        field.selectDefaultValue();

        this.link.record.fields.push(field);
      }
      else {
        field.model = fieldModel;
      }

      // Inpi field
      if (this.inpiFieldErrors) {
        const fullFieldName = `${this.link.name}.${field.name}`;

        const inpiField = this.inpiFieldErrors.find(f => f.name === fullFieldName);

        if (inpiField) {
          field.inpiFieldError = inpiField;
        }
      }

      // Name field needs validation
      if(field.model.input === 'text' && field.model.is_name) {
        let control = new FormControl(field.value, [
          Validators.required
        ]);

        control.valueChanges.subscribe((value) => {
          field.value = value;
        });

        if(this.link.record.is_root && !linkModel.is_root) {
          control.disable();
        }

        field.control = control;

        nameField = field;
      }
      // Other fields
      else {
        recordFields.push(field);
      }
    });

    // Make sure the type control is the first one followed by the name control
    this.fields = [
      typeField,
      nameField,
      ...recordFields,
      ...linkFields
    ];
  }

  onFixIssue() {
    this.fixIssue.emit();

    return false;
  }

  fixInpiError(event: Event, field: RecordField) {
    event.preventDefault();
    
    field.value = field.inpiFieldError.valid;
  }

  private refreshTotalShares() {
    let control:FormControl = this.totalSharesField.control;

    let total = 0;

    each(this.sharesFields, f => {
      let value = parseInt(f.value, 10);
      
      if(value > 0) {
        total += value;
      }
    });

    control.setValue(total.toString());
  }
}